'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _Pane = require('./Pane');

var _Pane2 = _interopRequireDefault(_Pane);

var _Overlay = require('./Overlay');

var _Overlay2 = _interopRequireDefault(_Overlay);

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var majorScale = _theme2.default.majorScale,
    minorScale = _theme2.default.minorScale;


var BottomSheetTopBar = function BottomSheetTopBar(_ref) {
  var left = _ref.left,
      right = _ref.right,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['left', 'right', 'children']);

  return _react2.default.createElement(
    _Pane2.default,
    _extends({ display: 'flex', top: '0', position: 'fixed', width: '100%', style: { zIndex: '10' }, alignItems: 'center', shadow: true, white: true }, props),
    _react2.default.createElement(
      _Pane2.default,
      { width: '33%', height: '100%', padding: minorScale(2), display: 'flex' },
      left
    ),
    _react2.default.createElement(
      _Pane2.default,
      { flexAuto: true, textAlign: 'center' },
      children
    ),
    _react2.default.createElement(
      _Pane2.default,
      { width: '33%', textAlign: 'right', padding: minorScale(2) },
      right
    )
  );
};

BottomSheetTopBar.propTypes = {
  left: _propTypes2.default.node,
  right: _propTypes2.default.node
};

BottomSheetTopBar.displayName = 'BottomSheetTopBar';

var BottomSheetCloseButton = function BottomSheetCloseButton(props) {
  return _react2.default.createElement(
    _Button2.default,
    _extends({ paddingX: majorScale(3) }, props),
    'Cancel'
  );
};

var slideInAnimation = _glamor.css.keyframes('slideInAnimation', {
  from: {
    transform: 'translateY(100%)'
  },
  to: {
    transform: 'translateY(0)'
  }
});

var slideOutAnimation = _glamor.css.keyframes('slideOutAnimation', {
  from: {
    transform: 'translateY(0)'
  },
  to: {
    transform: 'translateY(100%)'
  }
});

var BottomSheetPane = function BottomSheetPane(_ref2) {
  var slideOut = _ref2.slideOut,
      props = _objectWithoutProperties(_ref2, ['slideOut']);

  return _react2.default.createElement(_Pane2.default, _extends({}, (0, _glamor.css)({
    transform: 'translateZ(0)',
    animation: (slideOut ? slideOutAnimation : slideInAnimation) + ' ' + _theme2.default.animationDuration.slow + ' ' + _theme2.default.animationEasing.deceleration
  }), props));
};

BottomSheetPane.propTypes = {
  slideOut: _propTypes2.default.bool
};

BottomSheetPane.defaultProps = {
  tint: true,
  position: 'absolute',
  shadow: true,
  height: '100vh',
  paddingTop: majorScale(7),
  left: 0,
  right: 0,
  bottom: 0
};

BottomSheetPane.displayName = 'BottomSheetPane';

var BottomSheet = function (_Component) {
  _inherits(BottomSheet, _Component);

  function BottomSheet(props, context) {
    _classCallCheck(this, BottomSheet);

    var _this = _possibleConstructorReturn(this, (BottomSheet.__proto__ || Object.getPrototypeOf(BottomSheet)).call(this, props, context));

    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleAnimationEnd = _this.handleAnimationEnd.bind(_this);

    _this.state = {
      isClosing: false
    };
    return _this;
  }

  _createClass(BottomSheet, [{
    key: 'handleClose',
    value: function handleClose() {
      this.setState({ isClosing: true });
    }
  }, {
    key: 'handleAnimationEnd',
    value: function handleAnimationEnd() {
      if (!this.state.isClosing) return;
      this.props.onClose();
      this.setState({ isClosing: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpen = _props.isOpen,
          children = _props.children,
          navigationBarLeft = _props.navigationBarLeft,
          navigationBarRight = _props.navigationBarRight,
          title = _props.title,
          props = _objectWithoutProperties(_props, ['isOpen', 'children', 'navigationBarLeft', 'navigationBarRight', 'title']);

      var isClosing = this.state.isClosing;


      if (!isOpen) return null;

      return _react2.default.createElement(
        _Overlay2.default,
        { onClick: this.handleClose, fadeOut: isClosing, onFadeEnd: this.handleAnimationEnd },
        _react2.default.createElement(
          BottomSheetPane,
          _extends({ onClick: function onClick(e) {
              return e.stopPropagation();
            }, slideOut: isClosing }, props),
          _react2.default.createElement(
            BottomSheetTopBar,
            { left: _react2.default.cloneElement(navigationBarLeft, { onClick: this.handleClose }), right: navigationBarRight },
            _react2.default.createElement(
              _Text2.default,
              { is: 'h2', textStyle: 'display4' },
              title
            )
          ),
          _react2.default.createElement(
            _Pane2.default,
            { style: { overflowY: 'auto' }, height: '100%' },
            children
          )
        )
      );
    }
  }]);

  return BottomSheet;
}(_react.Component);

BottomSheet.propTypes = {
  isOpen: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  navigationBarLeft: _propTypes2.default.node,
  navigationBarRight: _propTypes2.default.node,
  title: _propTypes2.default.string
};

BottomSheet.defaultProps = {
  isOpen: true,
  navigationBarLeft: _react2.default.createElement(BottomSheetCloseButton, null),
  navigationBarRight: null,
  title: null
};

BottomSheet.displayName = 'BottomSheet';

exports.default = BottomSheet;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/BottomSheet.js
// module id = 1116
// module chunks = 0